const items = [
  "DATA & ANALYTICS MODERNIZATION",
  "DATA PLATFORMS & ARCHITECTURE",
  "SEMANTIC LAYER & METRIC CONTRACTS",
  "GOVERNANCE & LINEAGE",
  "ENTERPRISE AI WORKFLOWS",
  "DECISION INTELLIGENCE & LEARNING",
];

export default function EditorialMarquee() {
  const line = items.map((item) => <span key={item} className="marquee-line"><b>·</b>{item}</span>);
  return (
    <section className="marquee-section" data-testid="editorial-marquee" aria-label="Data to decision areas of research">
      <div className="marquee-viewport">
        <div className="marquee-track" aria-hidden="true">
          <div className="marquee-line">{line}</div>
          <div className="marquee-line">{line}</div>
        </div>
      </div>
    </section>
  );
}
